import {RequestRegisterStatus} from "../generated-model/model";

export const compareWithId = (o1:{id:any}, o2:{id:any}): boolean => (o1 == o2) || ((!!o1 && !!o2) && (o1.id === o2.id));

export const compareWithRequestRegisterStatus = (o1: RequestRegisterStatus, o2: RequestRegisterStatus): boolean => (o1 === o2);
